import React, { useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../store";
import ExperienceDisplay from "../Experience/ExperienceDisplay";
import EducationDisplay from "../Education/EducationDisplay";
import ProjectDisplay from "../Projects/ProjectDisplay";
import "./Finish.css";
import { UserExperince, UserEducation, UserProject } from "../Profile";

type FinishProps = {
  handleClick: () => void;
};

export const Finish: React.FC<FinishProps> = ({ handleClick }) => {
  const user = useSelector((state: AppState) => state.user); // get the current user object from the Redux store
  const [education] = useState<UserEducation[]>(
    user.educations == undefined ? [] : user.educations
  );
  const [experiences] = useState<UserExperince[]>(
    user.experiences == undefined ? [] : user.experiences
  );
  const [projects] = useState<UserProject[]>(
    user.projects == undefined ? [] : user.projects
  );

  return (
    <div className="mx-4 flex flex-col md:mx-0">
      <div className="flex flex-row justify-between">
        <p className="text-blue mb-4 text-3xl font-bold lg:text-4xl xl:text-5xl 2xl:text-6xl">
          {user.name}
        </p>

        <button
          className="start-button flex px-10 py-2 text-lg font-bold md:py-4 md:text-xl lg:px-16 lg:text-3xl"
          onClick={handleClick}
        >
          Submit
        </button>
      </div>
      <div className="flex flex-col pt-4 md:flex-row md:justify-between md:space-x-10 md:pt-10 ">
        <div className="flex h-full w-full flex-col justify-between md:w-1/4">
          <p className="text-light mb-10 text-2xl font-bold lg:text-3xl xl:text-4xl">
            <span className="text-blue">CONTACT</span>
          </p>

          <div className="mt-2 overflow-y-scroll rounded-md bg-[#1E1E1E] p-2 md:max-h-[10rem]">
            <p className="text-light mb-4 h-[10rem] overflow-y-scroll rounded-md bg-[#1E1E1E] p-2 font-code text-sm font-bold md:h-[10rem] lg:text-base xl:text-lg">
              <p className="text-orange mb-4 hyphens-auto text-lg font-bold lg:text-xl xl:text-2xl">
                {user.email}
              </p>
              <p className="text-blue mb-4 text-lg font-bold lg:text-xl xl:text-2xl">
                {user.phone}
              </p>
              <p className="text-orange mb-4 hyphens-auto text-lg font-bold lg:text-xl xl:text-2xl">
                {user.linkedin}
              </p>
            </p>
          </div>

          <p className="text-light mb-10 mt-4 text-2xl font-bold lg:text-3xl xl:text-4xl">
            <span className="text-orange">SKILLS</span>
          </p>

          <div className="mt-2 overflow-y-scroll rounded-md bg-[#1E1E1E] p-2 md:max-h-[15rem]">
            <p className="text-light mb-4 h-[10rem] overflow-y-scroll rounded-md bg-[#1E1E1E] p-2 font-code text-sm font-bold md:h-[15rem] lg:text-base xl:text-lg">
              {user.skills.join(", ")}

              {user.skills.length === 0 && (
                <h1 className="font-code text-lg font-bold text-[#9CA3AF] lg:text-xl xl:text-2xl">
                  No skills added...
                </h1>
              )}
            </p>
          </div>
        </div>
        <div className="h-full w-full pt-4 md:w-1/4 md:pt-0 ">
          <p className="text-light mb-10 text-2xl font-bold lg:text-3xl xl:text-4xl">
            <span className="text-orange">EDUCATION</span>
          </p>
          <div className="h-[10rem] overflow-y-scroll rounded-md bg-[#1E1E1E] p-2 md:h-[40rem]">
            {education.map((ed, index) => {
              return (
                <EducationDisplay
                  key={index}
                  degree={ed.degree}
                  school={ed.school}
                  start_time={ed.start_date}
                  end_time={ed.end_date}
                  index={index}
                  deleteRow={undefined}
                />
              );
            })}
          </div>
        </div>
        <div className="w-9/10 h-full pt-4 md:w-1/4 md:pt-0 ">
          <p className="text-light mb-10 text-2xl font-bold lg:text-3xl xl:text-4xl">
            <span className="text-blue">EXPERIENCE</span>
          </p>
          <div className=" h-[10rem] overflow-y-scroll rounded-md bg-[#1E1E1E] p-2 md:h-[40rem]">
            {experiences.map((exp, index) => {
              return (
                <ExperienceDisplay
                  key={index}
                  role={exp.role}
                  company={exp.company}
                  start_time={exp.start_time}
                  end_time={exp.end_time}
                  index={index}
                  deleteRow={undefined}
                />
              );
            })}
          </div>
        </div>
        <div className="h-full w-full pt-4 md:w-1/4 md:pt-0 ">
          <p className="text-light mb-10 text-2xl font-bold lg:text-3xl xl:text-4xl">
            <span className="text-orange">PROJECTS</span>
          </p>
          <div className=" h-[10rem] overflow-y-scroll rounded-md bg-[#1E1E1E] p-2 md:h-[40rem]">
            {projects.map((proj, index) => {
              return (
                <ProjectDisplay
                  key={index}
                  name={proj.name}
                  personal={proj.personal}
                  organization={proj.organization}
                  start_time={proj.start_time}
                  end_time={proj.end_time}
                  index={index}
                  deleteRow={undefined}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
